import type { ApiUserForOrganization } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type OrganizationUsersLoadedEvent = AvvirEvent<typeof ORGANIZATION_USERS_LOADED, { users: ApiUserForOrganization[] }>

const organizationUsersLoaded = (users: ApiUserForOrganization[]): OrganizationUsersLoadedEvent => ({
  type: ORGANIZATION_USERS_LOADED,
  payload: { users }
});

export const ORGANIZATION_USERS_LOADED = "organization_users_loaded";

export default organizationUsersLoaded;
